













































































































































































































import Vue from 'vue'
import {
  PostService,
  CategoryService,
  ProductService,
  UserPurchaseService,
  UserPostCompletionService,
  getUserId,
  UserProductTrackingService,
  AssessmentStatusService,
  AssignmentService
} from '@/services'
import CategoryPostBreadcrumbs from '@/components/common/CategoryPostBreadcrumbs.vue'
import { Button, Notice } from 'view-design'
import { createCategoryPostTree, computeNextPost, sliceLongText } from '../helper'
import { adminMode } from '@/helper/permission.helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import UISpinner from '@/components/common/UISpinner.vue'
import AssignmentStatus from '@/components/assessments/AssignmentStatus.vue'
import Editor from '@tinymce/tinymce-vue'
import { assignmentEditorConfig, ASSIGNMENT_CHARACTER_LENGTH } from '@/helper/constants'
import AssignmentFilesUpload from '@/components/common/AssignmentFilesUpload.vue'
import { UploadedFile } from '@/helper/interfaces'


export default Vue.extend({
  data() {
    return {
      post: {},
      category: {},
      product: {},
      parentCategory: {},
      nextPost: {},
      assessmentStatus: null,
      categoryTree: [],
      submittingAnswer: false,
      showingResults: false,
      postMarkedAsCompleted: false,
      disablePostCompletionButton: false,
      productStarted: true,
      fetching: true,
      answer: '',
      submitedFiles: [],
      assignment: {},
      showErrorMessage: false
    }
  },
  components: {
    CategoryPostBreadcrumbs,
    Button,
    BaseIcon,
    UISpinner,
    AssignmentStatus,
    editor: Editor,
    AssignmentFilesUpload
  },
  computed: {
    answerExceedsMaxLength(): boolean {
      return this.answer.length > ASSIGNMENT_CHARACTER_LENGTH
    },
    assignmentCharacterLength() {
      return ASSIGNMENT_CHARACTER_LENGTH || 2000
    },
    editorConfig() {
      return assignmentEditorConfig
    },
    postId() {
      return this.$route.params.post_id
    },
    productId() {
      return this.post.productId
    },
    categoryId() {
      return this.$route.params.category_id
    },
    themeSettings(): object {
      return this.product.customizations?.lessonSettings?.themeSettings
    },
    goBackIcon(): string {
      if (this.sections?.courseNavigation?.breadCrumb?.color) {
        return this.sections?.courseNavigation?.breadCrumb?.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#111827'
    },
    parentCategoryTitle(): string {
      return sliceLongText(this.parentCategorytitle?.title)
    },

    categoryTitle(): string {
      return sliceLongText(this.category.title)
    },

    postTitle(): string {
      return sliceLongText(this.post.title)
    },

    lessonSettings(): object {
      return this.product.customizations?.lessonSettings
    },
    lessonBody(): object {
      return this.lessonSettings?.sections?.lessonBody
    },
    lessonButton(): object {
      return this.lessonBody?.button || null
    },
    postCompletionButtonText(): string {
      if (this.disablePostCompletionButton) {
        return this.postMarkedAsCompleted
          ? 'Marking as Incomplete'
          : 'Completing..'
      } else {
        return this.postMarkedAsCompleted
          ? 'Completed'
          : this.lessonButton?.content
          ? this.lessonButton.content
          : 'Mark As Complete'
      }
    },
    isAdmin() {
      return adminMode()
    }
  },
  async mounted() {
    this.fetching = true
    await Promise.all([
      this.fetchAssignment(),
      this.fetchPost(),
      this.fetchCategory(),
    ])
    await this.checkIfPostCompleted(this.postId)
    await this.createCategoryTree()
    await this.fetchProduct()
    await this.fetchNextPost()
    if (this.$route.query.review === true) {
      this.showingResults = true
      this.getLastSubmission()
    }
    this.fetching = false
  },
  methods: {
    trimFileName(name: string) {
      if (name && name.length > 20) return `${name.slice(0, 20)}...`
      return name
    },
    async fetchAssignment() {
      try {
        this.assignment = await AssignmentService.findById(this.postId)
      } catch (error) {
        console.error(`Error fetching assignment: ${JSON.stringify(error)}`)
      }
    },
    async submitAssignment() {
      try {
        this.showErrorMessage = false
        if (!this.answer && this.submitedFiles.length === 0) {
          this.showErrorMessage = true
          return
        }

        if(this.answerExceedsMaxLength) {
          return
        }

        await AssessmentStatusService.create({
          postId: this.postId,
          assignmentId: this.assignment.id,
          productId: this.productId,
          submission: this.submitedFiles,
          submissionType: 'assignment',
          answer: this.answer
        })

        this.backtoCurrentPost()
      } catch (error) {
        console.error(`Error submitting assignment: ${JSON.stringify(error)}`)
      }
    },
    async deleteFiles(id: number) {
      this.submitedFiles = this.submitedFiles.filter((file, index) => index !== id)
    },
    filesUploaded(files: Array<UploadedFile>) {
      this.submitedFiles.push(...files)
    },
    async checkIfPostCompleted(postId: string) {
      try {
        this.fetchingPostCompletionStatus = true

        const data = await UserPostCompletionService.checkIfPostCompleted(
          postId
        )

        if (data && data.length) {
          this.post.postCompletedRef = data[0].id
          this.postMarkedAsCompleted = true
        } else {
          this.postMarkedAsCompleted = false
        }
      } catch (error) {
        console.error('Error while checking if post is completed --> ', error)
      } finally {
        this.fetchingPostCompletionStatus = false
      }
    },
    async markPostAsCompleted() {
      const data = await UserPostCompletionService.markPostAsCompleted({
        postId: this.postId,
        productId: this.productId
      })

      this.post.postCompletedRef = data.id
    },
    async markPostAsIncomplete() {
      if (this.post.postCompletedRef) {
        await UserPostCompletionService.markPostAsIncomplete(
          this.post.postCompletedRef
        )
      }

      this.post.postCompletedRef = null
    },
    async togglePostCompletion() {
      try {
        this.disablePostCompletionButton = true

        if (this.postMarkedAsCompleted) {
          await this.markPostAsIncomplete()
          this.postMarkedAsCompleted = false
        } else {
          if (!this.productStarted) {
            UserProductTrackingService.trackProductStart(this.productId)
          }
          await this.markPostAsCompleted()
          this.postMarkedAsCompleted = true
          await this.fetchNextPost()
        }
      } catch (error) {
        console.error('error while changing post completion status --> ', error)
      } finally {
        this.disablePostCompletionButton = false
      }
    },
    async createCategoryTree() {
      const categories = await UserPurchaseService.getCategories({
        product_id: this.productId
      })

      this.categoryTree = createCategoryPostTree(null, categories)
    },
    async fetchNextPost() {
      // fetch user post completion data
      const userId = getUserId()

      const completedResp = await UserPostCompletionService.findAll({
        product_id: this.productId,
        user_id: userId
      })

      const postIdsCompleted = completedResp.reduce(
        (agg: Set<string>, completed: any) => {
          const { postId } = completed
          agg.add(postId)
          return agg
        },
        new Set()
      )

      const nextPost = computeNextPost(this.categoryTree, postIdsCompleted)
      this.nextPost = nextPost ? nextPost.node : null
    },
    goToNextPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.productId,
          category_id: this.nextPost.categoryId,
          post_id: this.nextPost.id
        }
      })
    },
    backtoCurrentPost() {
      this.$router.push({
        name: 'post-overview',
        params: {
          id: this.product.id,
          category_id: this.category.id,
          post_id: this.post.id
        }
      })
    },
    async fetchPost() {
      try {
        this.post = await PostService.findById(this.postId)
      } catch (error) {
        console.error(`Error fetching post: ${error}`)
      }
    },
    async fetchCategory() {
      try {
        this.category = await CategoryService.findById(this.categoryId)
        if (this.category.parentCategory) {
          this.parentCategory = await CategoryService.findById(this.category.parentCategory)
        }
      } catch (error) {
        console.error(`Error fetching Category: ${error}`)
      }
    },
    async fetchProduct() {
      try {
        this.product = await ProductService.findById(this.productId)
      } catch (error) {
        console.error(`Error fetching Product: ${error}`)
      }
    }
  }
})
